module.exports = __webpack_public_path__ + "img/1325674125.05332c4e.jpg";